import { some } from 'lodash';
import React from 'react';

const STRING_SPLIT_REGEX = /(<.*?>)/;
const STRING_MATCH_REGEX = /<(.*?)>/;

const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const interpolateAsString = (string, map) => {
  if (!string || !map) return '';
  let replacedString = string;

  Object.keys(map).forEach((key) => {
    const regex = new RegExp(`<${escapeRegExp(key)}>`, 'gi');
    replacedString = replacedString.replace(regex, map[key]);
  });

  return replacedString;
};

export const interpolate = (string, componentMap) => {
  if (string && some(componentMap, React.isValidElement)) {
    return React.createElement(
      React.Fragment,
      null,
      ...string.split(STRING_SPLIT_REGEX).map((item) => {
        if (item.startsWith('<')) {
          const found = item.match(STRING_MATCH_REGEX);
          if (found) {
            return componentMap[found[1]] ?? null;
          }
        }
        return item;
      }),
    );
  }
  return interpolateAsString(string, componentMap);
};
